import { jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
const ParticleBlob = ({ level, size }) => {
  const canvasRef = useRef(null);
  const levelRef = useRef(level);
  useEffect(() => {
    levelRef.current = level;
  }, [level]);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const dpr = typeof window !== "undefined" && window.devicePixelRatio || 1;
    canvas.width = size * dpr;
    canvas.height = size * dpr;
    ctx.scale(dpr, dpr);
    const RINGS = [
      { count: 36, radius: size * 0.28, hue: 190 },
      { count: 28, radius: size * 0.345, hue: 215 },
      { count: 20, radius: size * 0.4, hue: 240 }
    ];
    const particles = [];
    RINGS.forEach((ring) => {
      for (let i = 0; i < ring.count; i++) {
        particles.push({
          a: i / ring.count * Math.PI * 2 + Math.random() * 0.12,
          baseR: ring.radius + (Math.random() - 0.5) * 3,
          speed: 25e-4 + Math.random() * 2e-3,
          phase: Math.random() * Math.PI * 2,
          sz: 1.2 + Math.random() * 1.4,
          hue: ring.hue + Math.random() * 25 - 12
        });
      }
    });
    let raf;
    const draw = () => {
      ctx.clearRect(0, 0, size, size);
      const cx = size / 2;
      const cy = size / 2;
      const l = levelRef.current;
      const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, size * 0.25 + l * size * 0.16);
      grad.addColorStop(0, `rgba(120,220,255,${0.55 + l * 0.35})`);
      grad.addColorStop(1, "rgba(120,220,255,0)");
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, size, size);
      for (const p of particles) {
        p.a += p.speed * (1 + l * 1.5);
        const breathe = Math.sin(performance.now() * 2e-3 + p.phase) * 2;
        const rr = p.baseR + breathe + l * 10;
        const x = cx + Math.cos(p.a) * rr;
        const y = cy + Math.sin(p.a) * rr;
        ctx.beginPath();
        ctx.fillStyle = `hsla(${p.hue}, 95%, ${65 + l * 15}%, ${0.55 + l * 0.4})`;
        ctx.arc(x, y, p.sz + l * 1.2, 0, Math.PI * 2);
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, [size]);
  return /* @__PURE__ */ jsx("canvas", { ref: canvasRef, style: { width: size, height: size }, "aria-hidden": true });
};
export {
  ParticleBlob
};
//# sourceMappingURL=ParticleBlob.js.map
